var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCheckBoxSelected(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M27 8.47209L15.4638 20.8628C14.7402 21.64 13.5354 21.7162 12.7196 21.0364L6.71963 16.0364C5.87108 15.3293 5.75643 14.0682 6.46356 13.2196C7.17069 12.3711 8.43182 12.2564 9.28037 12.9636L13.8261 16.7517L25.3933 4.3277C24.5019 3.50359 23.3097 3 22 3H8C5.23858 3 3 5.23858 3 8V22C3 24.7614 5.23858 27 8 27H22C24.7614 27 27 24.7614 27 22V8.47209Z",
    fill: "#0071FF"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckBoxSelected);
export default __webpack_public_path__ + "static/media/checkBoxSelected.fd4a37314894da4916a4ea4952c9aa44.svg";
export { ForwardRef as ReactComponent };